import clientStorage from "../../services/clientStorage";
import platformStorage from "../../services/clientStorage/platformStorage";
import { LANGUAGE_PREFERENCE_KEY, LOCALIZATION_CACHE_KEY_PREFIX } from "./constants";
import localizationLogger from "./localizationLogger";
import { SupportedLanguage } from "./types";
const MIGRATION_MARKER_KEY = "legacyLocalizationStorageMigrated";
const MIGRATION_MARKER_VALUE = "1";
const buildLegacyKeys = () => [
    LANGUAGE_PREFERENCE_KEY,
    ...Object.values(SupportedLanguage).map((language) => `${LOCALIZATION_CACHE_KEY_PREFIX}${language}`),
];
const moveLegacyKey = async (legacyKey) => {
    const legacyValue = await platformStorage.getItem(legacyKey);
    if (legacyValue === null) {
        return;
    }
    await platformStorage.removeItem(legacyKey);
    await clientStorage.setItem(legacyKey, legacyValue);
};
const logMigrationFailure = (migrationError) => {
    localizationLogger.error("Failed to migrate legacy localization keys", migrationError);
};
// TODO(hassanahmad): [NX-12172] Remove one-time legacy localization storage migration after end of September 2026.
const migrateLegacyLocalizationStorage = async ({ reportMigrationError = logMigrationFailure, } = {}) => {
    try {
        const migrationMarker = await clientStorage.getItem(MIGRATION_MARKER_KEY);
        if (migrationMarker === MIGRATION_MARKER_VALUE) {
            return;
        }
        await Promise.all(buildLegacyKeys().map(moveLegacyKey));
        await clientStorage.setItem(MIGRATION_MARKER_KEY, MIGRATION_MARKER_VALUE);
    }
    catch (migrationError) {
        reportMigrationError(migrationError);
    }
};
export default migrateLegacyLocalizationStorage;
